import { render } from "./App.vue?vue&type=template&id=2f64ce28"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2f64ce28&lang=stylus"

import exportComponent from "D:\\tokyo-shoseki_R6_0124\\06pk\\s\\5a\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__